import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7d0d2c9b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "custom-footer" }

import { computed, ref, h, onMounted } from 'vue';
import { FormInstance, FormRules, ElAlert } from 'element-plus';
import { EMessage, EMessageBox } from '@aciga/e-ui-next';
import { get } from 'lodash-es';
import { getProjectAllRole } from '@/api/role';
import EDrawer from '@/components/bussiness/e-drawer/index.vue';
import { createOrUpdateVGroup, getVGroupsRoles } from '@/api/virtualGroup';
import { getLoginProjects } from '@/api/myAuth';
import { useUserStore } from '@/store';
import AutotrimInput from '@/components/autotrim-input/AutotrimInput.vue';

interface Props {
  drawerVisible: boolean;
  vGroupInfo?: VirtualGroup.GroupItem;
  type: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'editVGroupDrawer',
  props: {
    drawerVisible: { type: Boolean, default: false },
    vGroupInfo: { default: () => ({
    groupId: '系统生成，不可修改',
    groupName: '',
    status: 0,
    groupDesc: '',
    createTime: 0,
    bindRoles: []
  }) },
    type: { default: 'create' }
  },
  emits: ['update:drawerVisible', 'on-success'],
  setup(__props: any, { emit: __emit }) {

const userStore = useUserStore();
const props = __props;

const emit = __emit;

const drawerShow = computed({
  get: () => props.drawerVisible,
  set: (val) => {
    emit('update:drawerVisible', val);
  }
});

// 系统/项目id数组。
const sysProId = ref<number[]>([]);
// 系统项目 二级树
const systemProjectTree = ref<any[]>([]);

const formRef = ref<FormInstance>();
const formData = ref<VirtualGroup.GroupItem>({
  groupId: '系统生成，不可修改',
  groupName: '',
  status: 0,
  groupDesc: '',
  createTime: 0,
  bindRoles: []
});

const formRules = ref<FormRules>({
  groupName: [{ required: true, message: '请输入虚拟组名称', trigger: ['blur', 'change'] }],
  status: [{ required: true, message: '请选择虚拟组状态', trigger: ['blur', 'change'] }],
  bindRoles: [{ required: true, message: '请选择绑定角色', trigger: ['blur', 'change'] }]
});

const onCancel = () => {
  EMessageBox({
    title: props.type === 'create' ? '取消创建虚拟组' : '取消编辑虚拟组',
    message: h(ElAlert, {
      title: props.type === 'create' ? '确认取消创建' : '确认取消编辑',
      type: 'warning',
      showIcon: true,
      closable: false
    }),
    confirmButtonText: '确定',
    cancelButtonText: '取消',
    effect: 'cm',
    type: 'alert'
  }).then(async () => {
    drawerShow.value = false;
  });
};

const saveLoading = ref(false);
const saveOrUpdate = (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  formEl.validate(async (valid) => {
    if (valid) {
      saveLoading.value = true;
      try {
        // create
        if (props.type === 'create') {
          delete formData.value.groupId;
        }
        const res = await createOrUpdateVGroup(formData.value);
        const { code } = res || {};
        if (`${code}` === '0') {
          EMessage.success('保存成功');
          drawerShow.value = false;
          emit('on-success');
        }
        saveLoading.value = false;
      } catch (err) {
        saveLoading.value = false;
      }
    }
  });
};

const tipText = computed(() => `该用户在账户中心共${formData.value.bindRoles?.length || 0}个角色`);

const projectList = ref<Project.ProjectItem[]>([]);
const curProjectId = ref<number | undefined>();
const curRoleList = ref<Role.RoleItem[]>([]);
const selectedRoleIdArr = ref<number[]>([]); // 全部项目的角色id 都传入，冗余但方便

// 记录已经加载的项目以及项目下所有角色，用作缓存
const projectRoleListMapCache = new Map<number, Role.RoleItem[]>();

// 记录所有角色map, 提交数据时使用
const roleMap = new Map<number, Role.SimpleRoleItem>();

onMounted(async () => {
  userStore.getSystemProjectsTree().then((res) => {
    systemProjectTree.value = res;
  });
  const { vGroupInfo } = props;
  formData.value = vGroupInfo;

  const res = await getLoginProjects();
  const { code, data } = res;
  if (`${code}` === '0') {
    projectList.value = data.loginProject || [];
    if (get(formData.value, 'roles.length', 0) > 0) {
      curProjectId.value = formData.value.bindRoles[0].projectId as number;
    } else {
      curProjectId.value = projectList.value[0].projectId as number;
    }
    getRoleListByProjectId(curProjectId.value);

    const myAuthProjectIds = (data.loginProject || []).map((item) => item.projectId);
    if (props.type === 'edit') {
      const roleRes = await getVGroupsRoles({
        groupId: vGroupInfo.groupId as number,
        myAuthProjectIds: myAuthProjectIds as number[]
      });
      const { code: resCode, data: resData } = roleRes || {};
      if (`${resCode}` === '0') {
        formData.value.bindRoles = (resData.roleList || []) as any;
        formData.value.bindRoles.forEach((role) => {
          // @ts-ignore
          delete role.class; // 去掉后端多余字段
          roleMap.set(role.roleId as number, role);
        });
        selectedRoleIdArr.value = formData.value.bindRoles.map((e) => e.roleId as number);
      }
    }
  }
});

const getRoleListByProjectId = async (projectId: number) => {
  if (projectRoleListMapCache.get(projectId)) {
    curRoleList.value = projectRoleListMapCache.get(projectId) as any;
    return;
  }
  const res = await getProjectAllRole(projectId);
  const { code, data } = res || {};
  if (`${code}` === '0') {
    projectRoleListMapCache.set(projectId, data.roleList);
    curRoleList.value = data.roleList;
    data.roleList.forEach((role) => {
      // @ts-ignore
      delete role.class; // 去掉后端多余字段
      roleMap.set(role.roleId as number, role);
    });
  }
};

// 切换项目
// 系统改变的回调，获取角色列表
const onChangeProject = () => {
  const [sysId, projectId] = sysProId.value;
  if (!projectId || !sysId) {
    console.error('获取系统id，或者项目id失败');
    return;
  }
  getRoleListByProjectId(projectId);
};
// const onProjectChange = (projectId: number) => {
//   getRoleListByProjectId(projectId);
// };

// 角色勾选改变
const changeSelectedRoleIdArr = (arr: number[]) => {
  formData.value.bindRoles = arr.map((id) => roleMap.get(id) as Role.SimpleRoleItem);
};

return (_ctx: any,_cache: any) => {
  const _component_e_form_item = _resolveComponent("e-form-item")!
  const _component_e_radio = _resolveComponent("e-radio")!
  const _component_e_radio_group = _resolveComponent("e-radio-group")!
  const _component_e_cascader = _resolveComponent("e-cascader")!
  const _component_e_checkbox = _resolveComponent("e-checkbox")!
  const _component_e_checkbox_group = _resolveComponent("e-checkbox-group")!
  const _component_e_form = _resolveComponent("e-form")!
  const _component_e_button = _resolveComponent("e-button")!

  return (_openBlock(), _createBlock(EDrawer, {
    modelValue: drawerShow.value,
    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((drawerShow).value = $event)),
    direction: "rtl",
    title: _ctx.type === 'create' ? '添加虚拟组' : '编辑虚拟组',
    size: "45%",
    "show-footer": true,
    "show-close": false,
    onConfirm: saveOrUpdate,
    onCancel: onCancel
  }, {
    footer: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_ctx.type === 'create')
          ? (_openBlock(), _createBlock(_component_e_button, {
              key: 0,
              loading: saveLoading.value,
              type: "main",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (saveOrUpdate(formRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("创建")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        (_ctx.type !== 'create')
          ? (_openBlock(), _createBlock(_component_e_button, {
              key: 1,
              loading: saveLoading.value,
              type: "main",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (saveOrUpdate(formRef.value)))
            }, {
              default: _withCtx(() => [
                _createTextVNode("确定")
              ]),
              _: 1
            }, 8, ["loading"]))
          : _createCommentVNode("", true),
        _createVNode(_component_e_button, {
          type: "secondary",
          onClick: onCancel
        }, {
          default: _withCtx(() => [
            _createTextVNode("取消")
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_e_form, {
        ref_key: "formRef",
        ref: formRef,
        rules: formRules.value,
        model: formData.value,
        "label-width": "90px",
        "label-position": "right",
        "show-ellipsis": false
      }, {
        default: _withCtx(() => [
          _createVNode(_component_e_form_item, {
            label: "虚拟组ID",
            prop: "groupId"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: formData.value.groupId,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.value.groupId) = $event)),
                disabled: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "虚拟组名称",
            prop: "groupName"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: formData.value.groupName,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.value.groupName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "虚拟组状态",
            prop: "status"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_e_radio_group, {
                modelValue: formData.value.status,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.value.status) = $event))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_e_radio, { label: 1 }, {
                    default: _withCtx(() => [
                      _createTextVNode("正常")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_e_radio, { label: 0 }, {
                    default: _withCtx(() => [
                      _createTextVNode("停用")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "虚拟组说明",
            prop: "groupDesc"
          }, {
            default: _withCtx(() => [
              _createVNode(AutotrimInput, {
                modelValue: formData.value.groupDesc,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.value.groupDesc) = $event)),
                type: "textarea",
                maxlength: 400,
                style: {"max-width":"400px"},
                "show-word-limit": "",
                placeholder: "请输入虚拟组说明",
                clearable: ""
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, { "label-width": "0" }, {
            default: _withCtx(() => [
              _createVNode(_unref(ElAlert), {
                title: tipText.value,
                type: "success",
                closable: false
              }, null, 8, ["title"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, {
            label: "已选择角色",
            prop: "bindRoles"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString((formData.value.bindRoles || [])
              .map((e) => `${e.sysName}-${e.projectName}-${e.roleName}`)
              .join(';')), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, { label: "项目名称" }, {
            default: _withCtx(() => [
              _createVNode(_component_e_cascader, {
                modelValue: sysProId.value,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((sysProId).value = $event)),
                options: systemProjectTree.value,
                placeholder: "请选择项目",
                onChange: onChangeProject
              }, null, 8, ["modelValue", "options"])
            ]),
            _: 1
          }),
          _createVNode(_component_e_form_item, { label: "角色" }, {
            default: _withCtx(() => [
              _createVNode(_component_e_checkbox_group, {
                modelValue: selectedRoleIdArr.value,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((selectedRoleIdArr).value = $event)),
                class: "v-group",
                onChange: changeSelectedRoleIdArr
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(curRoleList.value, (role) => {
                    return (_openBlock(), _createBlock(_component_e_checkbox, {
                      key: role.roleId,
                      label: role.roleId
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(role.roleName), 1)
                      ]),
                      _: 2
                    }, 1032, ["label"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["rules", "model"])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})